/**
 * Preise-&-Pakete / Portalzugang: Direkt-in-den-Warenkorb + Cart-Drawer öffnen
 */

import { CartAddEvent } from '@theme/events';

const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
const ADD_URL = routes.cart_add_url || '/cart/add.js';
const CART_URL = routes.cart_url || '/cart';
const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

/**
 * Sammelt die Section-IDs aller Cart-Item-Listen im DOM (Drawer + ggf. Seite),
 * damit /cart/add.js deren frisches HTML mitliefert.
 * @returns {string[]}
 */
function getCartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

/**
 * Öffnet den Cart-Drawer explizit (Fallback, falls kein auto-open greift).
 */
function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }
  return false;
}

document.addEventListener('click', async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest('[data-pp-add]');
  if (!(button instanceof HTMLElement)) return;

  event.preventDefault();
  // Verhindert, dass der darunterliegende Karten-Link (Scroll zum Detail) auslöst.
  event.stopPropagation();
  if (button.getAttribute('aria-busy') === 'true') return;

  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  /** @type {{ id: number, quantity: number, selling_plan?: number }} */
  const item = { id: variantId, quantity: 1 };
  if (button.dataset.sellingPlan) item.selling_plan = Number(button.dataset.sellingPlan);

  const sectionIds = getCartSectionIds();
  /** @type {{ items: object[], sections?: string, sections_url?: string }} */
  const payload = { items: [item] };
  if (sectionIds.length) {
    payload.sections = sectionIds.join(',');
    payload.sections_url = window.location.pathname;
  }

  const originalLabel = button.textContent;
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Wird hinzugefügt …';

  try {
    const response = await fetch(ADD_URL, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      button.textContent = data.description || data.message || 'Nicht verfügbar';
      setTimeout(() => {
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      }, 2500);
      return;
    }

    // Frischen Warenkorb für Zähler/Item-Count holen (best effort).
    let cart = null;
    try {
      const cartResponse = await fetch(`${CART_URL}.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) cart = await cartResponse.json();
    } catch (e) {
      /* Zähler ist optional – Drawer öffnet trotzdem. */
    }

    // Theme benachrichtigen: Drawer-Inhalt morphen + öffnen, Header-Bubble aktualisieren.
    document.dispatchEvent(
      new CartAddEvent(cart || data, button.id || 'pricing-packages', {
        source: 'pricing-packages',
        didError: false,
        productId: button.dataset.productId,
        variantId: String(variantId),
        itemCount: cart ? cart.item_count : undefined,
        sections: data.sections,
      })
    );

    // Sicherstellen, dass der Drawer sichtbar wird (falls kein auto-open-Attribut).
    openCartDrawer();

    button.textContent = 'Hinzugefügt ✓';
    setTimeout(() => {
      button.textContent = originalLabel;
      button.removeAttribute('aria-busy');
    }, 1500);
  } catch (error) {
    console.error('[pricing-packages] Add-to-cart fehlgeschlagen:', error);
    button.textContent = originalLabel;
    button.removeAttribute('aria-busy');
  }
});
